<script>
import DateTimeInput from '@/components/form/advanced/datetime/DateTimeInput'

export default {
    name: 'oc-date-input',
    extends: DateTimeInput,
    props: {
        timePicker: {
            type: Boolean,
            default: false
        },
        autoApply: {
            type: Boolean,
            default: true
        }
    }
}
</script>
